export default "__VITE_ASSET___s8vF9N___"